import placeholderSvg from '../assets/placeholder-service.svg';
import { ServiceLocationInfo } from '../types/firestore';

const escapeHtmlAttribute = (value: string): string =>
  value.replace(/[&<>"']/g, (character) => {
    switch (character) {
      case '&':
        return '&amp;';
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#39;';
      default:
        return character;
    }
  });

const getPopupImageUrl = (marker: ServiceLocationInfo): string => {
  if (marker.isTestData === true) {
    return placeholderSvg;
  }

  const candidateUrl = typeof marker.imageUrl === 'string' ? marker.imageUrl.trim() : '';
  return candidateUrl.length > 0 ? candidateUrl : placeholderSvg;
};

export const buildServiceProviderPopupImageMarkup = (marker: ServiceLocationInfo): string => {
  const imageUrl = getPopupImageUrl(marker);
  const storagePath =
    typeof marker.imageStoragePath === 'string' ? marker.imageStoragePath.trim() : '';
  const warningPayload = escapeHtmlAttribute(
    JSON.stringify({
      component: 'MapComponent.MarkerPopupContent',
      providerId: marker.uid || null,
      variant: 'thumb',
      storagePath: storagePath || null,
    })
  );

  return [
    '<img',
    `src="${escapeHtmlAttribute(imageUrl)}"`,
    `alt="${escapeHtmlAttribute(marker.serviceName || 'Zdjęcie serwisu')}"`,
    'loading="lazy"',
    'decoding="async"',
    `data-fallback-src="${escapeHtmlAttribute(placeholderSvg)}"`,
    storagePath ? `data-storage-path="${escapeHtmlAttribute(storagePath)}"` : '',
    `data-diagnostic-context="${warningPayload}"`,
    "onerror=\"try{console.warn&&console.warn('[serviceProviderImage] render fallback',JSON.parse(this.dataset.diagnosticContext||'{}'))}catch(e){console.warn&&console.warn('[serviceProviderImage] render fallback')}this.onerror=null;this.src=this.dataset.fallbackSrc||''\"",
    'class="h-full w-full object-cover"',
    '/>',
  ]
    .filter(Boolean)
    .join(' ');
};

export const getServiceProviderRequestHref = (providerId: string): string =>
  `/app/request/new/${providerId}`;
